export const getLockedOrderId = () => {
  let id = localStorage.getItem("order_id");

  if (!id) {
    const now = new Date();
    
    const date = String(now.getDate());                        // DD
    const month = String(now.getMonth() + 1);                  // M
    const year = String(now.getFullYear()).slice(-2);          // YY
    const hours = String(now.getHours()).padStart(2, "0");      // HH
    const minutes = String(now.getMinutes()).padStart(2, "0");   // MM
    const seconds = String(now.getSeconds()).padStart(2, "0");   // SS

    id = `${date}${month}${year}${hours}${minutes}${seconds}`;
    localStorage.setItem("order_id", id);
  }
  

  return id;
};

export const resetOrderId = () => {
  localStorage.removeItem("order_id");
};